<template>
    <div>
        <template v-if="isMobile()">
            <div class="layout-topbar">
                <div class="flex justify-content-start">
                    <div class="flex align-items-start justify-content-center">
                        <button class="menu-button" @click="onMenuToggle">
                            <i class="menu-button-icon pi pi-bars"></i>
                        </button>
                    </div>
                </div>
                <div class="flex justify-content-end">
                    <template v-if="user.level >= 3">
                        <div class="flex align-items-end justify-content-center p-2">
                            <Dropdown
                                v-if="selectedDateRangeOption"
                                class="w-full tool-bar-container"
                                :model-value="selectedDateRangeOption"
                                @change="selectDateRange($event)"
                                :options="dateRangeOptions"
                                placeholder="Select date"
                            >
                                <template #value="slotProps">
                                    <span class="tool-bar-container-label">{{ slotProps.value.name }}</span>
                                </template>
                                <template #option="slotProps">
                                    <span class="tool-bar-container-label p-0">{{ slotProps.option.name }}</span>
                                </template>
                            </Dropdown>
                        </div>
                    </template>
                    <div class="flex align-items-end justify-content-center p-2">
                        <Dropdown
                            class="tool-bar-container"
                            @change="setLanguage($event)"
                            :model-value="locale"
                            :options="languagesMenuItems"
                        >
                            <template #value="locale">
                                <span class="tool-bar-container-date-picker">{{
                                    locale.value === "gb" ? "EN" : locale.value.toUpperCase()
                                }}</span>
                            </template>
                            <template #option="slotProps">
                                <span class="tool-bar-container-label p-0">{{ slotProps.option.label }}</span>
                            </template>
                        </Dropdown>
                    </div>
                    <div class="flex align-items-end justify-content-center p-2">
                        <router-link class="p-link layout-topbar-button" to="/profile" @click="menu = false">
                            <img
                                height="35"
                                width="35"
                                src="https://shoptok-assets.s3.eu-central-1.amazonaws.com/business_manager/profile.svg"
                            />
                            <span>{{ $t("components.common.appTopBar.profile") }}</span>
                        </router-link>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="layout-topbar px-2 md:pl-5 md:pr-3">
                <!-- <button class="menu-button" @click="onMenuToggle">
                    <i class="menu-button-icon pi" :class="[menu ? 'pi-angle-right' : 'pi-angle-left']"></i>
                </button> -->

                <ul
                    class="lg:relative layout-topbar-menu lg:flex lg:align-items-center origin-top"
                    :class="{ hidden: !menu }"
                >
                    <li v-if="user.level >= 3">
                        <div class="lg:mr-3">
                            <Dropdown
                                v-if="selectedDateRangeOption"
                                class="w-full mr-3 tool-bar-container"
                                :model-value="selectedDateRangeOption"
                                @change="selectDateRange($event)"
                                :options="dateRangeOptions"
                                placeholder="Select date"
                            >
                                <template #value="slotProps">
                                    <span class="tool-bar-container-label mr-2">{{ slotProps.value.name }}</span>
                                    <span class="tool-bar-container-text">{{
                                        `${formatDate(dateFrom)} - ${formatDate(dateTo)}`
                                    }}</span>
                                </template>
                                <template #option="slotProps">
                                    <span class="tool-bar-container-label p-0">{{ slotProps.option.name }}</span>
                                </template>
                            </Dropdown>
                        </div>
                    </li>
                    <li>
                        <Dropdown
                            class="tool-bar-container"
                            @change="setLanguage($event)"
                            :model-value="locale"
                            :options="languagesMenuItems"
                        >
                            <template #value="locale">
                                <span class="tool-bar-container-date-picker">{{
                                    locale.value === "gb" ? "EN" : locale.value.toUpperCase()
                                }}</span>
                            </template>
                            <template #option="slotProps">
                                <span class="tool-bar-container-label p-0">{{ slotProps.option.label }}</span>
                            </template>
                        </Dropdown>
                    </li>
                    <li>
                        <img
                            class="p-link layout-topbar-button"
                            src="https://shoptok-assets.s3.eu-central-1.amazonaws.com/business_manager/profile.svg"
                            @click="toggleProfileMenu"
                        />
                        <Menu id="overlay_menu" ref="profileMenu" :model="profileDropDownOptions" :popup="true">
                            <template #item="{ item }">
                                <template v-if="item.code == 'logout'">
                                    <a
                                        class="menu-logout tool-bar-container-label"
                                        @click.prevent="logout"
                                        style="cursor: pointer"
                                    >
                                        <span style="vertical-align: middle" class="pi pi-sign-out mr-2"></span>
                                        <span style="vertical-align: middle">{{
                                            $t("components.common.appTopBar.logOut")
                                        }}</span>
                                    </a>
                                </template>
                                <template v-if="item.code == 'profile'">
                                    <router-link class="tool-bar-container-label" to="/profile" @click="menu = false">
                                        <span class="pi pi-user mr-2" style="vertical-align: middle"></span>
                                        <span style="vertical-align: middle">{{ item.label }}</span></router-link
                                    >
                                </template>
                            </template>
                        </Menu>
                    </li>
                </ul>
            </div>
        </template>

        <Dialog
            :header="$t('pages.dashboard.choseDateRange')"
            :modal="true"
            @hide="selectedShops = []"
            class="dialog--small"
            contentClass="h-full flex flex-column sm:flex-row align-items-start px-0"
            v-model:visible="editDateModal"
        >
            <div class="w-full text-center mb-4" :style="{ minHeight: '405px' }">
                <Calendar
                    dateFormat="dd.mm.yy"
                    v-model="chosenDateRange"
                    selectionMode="range"
                    :manualInput="false"
                    :inline="true"
                    :maxDate="maxDate"
                />
            </div>
            <template #footer>
                <Button
                    :label="$t('general.apply')"
                    :loading="editDateLoading"
                    @click="confirmEditDateModal"
                    class="m-0"
                    icon="pi pi-check"
                />
            </template>
        </Dialog>
    </div>
</template>

<script>
import useHelpers from "@/composables/helpers";
import { computed, onMounted, ref, watch } from "vue";
import { getActivePinia } from "pinia";
import { storeToRefs } from "pinia";
import { useAppStore } from "../../store/app";
import { useAuthStore } from "../../store/auth";
import { useI18n } from "vue-i18n";
import { useMobileDetection } from "vue3-mobile-detection";
import { useShopStore } from "@/store/shop";
import { useUserStore } from "../../store/user";

export default {
    name: "AppTopBar",
    props: {},
    setup(props, { emit }) {
        const { t, locale } = useI18n({ useScope: "global" });
        const authStore = useAuthStore();
        const appStore = useAppStore();
        const userStore = useUserStore();
        const maxDate = ref(new Date());
        const search = ref("");
        const languageMenu = ref(false);
        const menu = ref(false);
        const selectedDateRangeOption = ref(null);
        const dateRangeOptions = ref([
            { name: t("components.common.appTopBar.dateRangeOptions.l7d"), code: "l7d" },
            { name: t("components.common.appTopBar.dateRangeOptions.l30d"), code: "l30d" },
            { name: t("components.common.appTopBar.dateRangeOptions.l90d"), code: "l90d" },
            { name: t("components.common.appTopBar.dateRangeOptions.mtd"), code: "mtd" },
            { name: t("components.common.appTopBar.dateRangeOptions.ytd"), code: "ytd" },
            { name: t("components.common.appTopBar.dateRangeOptions.cq"), code: "cq" },
            { name: t("components.common.appTopBar.dateRangeOptions.pq"), code: "pq" },
            { name: t("components.common.appTopBar.dateRangeOptions.ly"), code: "ly" },
            { name: t("components.common.appTopBar.dateRangeOptions.lm"), code: "lm" },
            { name: t("components.common.appTopBar.dateRangeOptions.custom"), code: "custom" },
        ]);
        const editDateModal = ref(false);
        const editDateLoading = ref(false);
        const { user } = storeToRefs(userStore);
        const { calendarRange, dateFrom, dateTo } = storeToRefs(appStore);
        const { fetchTableDataByReport, formatDate } = useHelpers();
        const shopStore = useShopStore();
        const { selectedShop } = storeToRefs(shopStore);
        const profileDropDownOptions = ref([
            { label: "Profile", code: "profile" },
            { label: "Log out", code: "logout" },
        ]);
        const profileMenu = ref();
        const chosenDateRange = ref(null);

        onMounted(() => {
            if (dateFrom.value === null && dateTo.value === null) {
                selectedDateRangeOption.value = dateRangeOptions.value.find((v) => v.code === "mtd");
                let date = new Date();

                let dateFrom = new Date(date.getFullYear(), date.getMonth(), 1);
                let dateTo = new Date(date.getFullYear(), date.getMonth(), date.getDate());

                calendarRange.value[0] = dateFrom;
                calendarRange.value[1] = dateFrom > dateTo ? dateFrom : dateTo;
            } else {
                selectedDateRangeOption.value = dateRangeOptions.value.find((v) => v.code === "custom");
            }

            chosenDateRange.value = calendarRange.value;
            changeLocale(user.value.lang ? user.value.lang : "gb");
        });

        const toggleLanguagesMenu = (event) => {
            languageMenu.value.toggle(event);
        };

        const onMenuToggle = (event) => {
            menu.value = menu.value ? false : true;
            emit("menuToggle", event);
        };

        const changeLocale = (localeValue) => {
            localStorage.setItem("locale", localeValue);
            locale.value = localeValue;
        };

        const logout = () => {
            authStore.logout();

            setTimeout(() => {
                getActivePinia()._s.forEach((store) => store.$reset());
            }, 1000);
        };

        const chosenLanguage = computed(() => {
            return localStorage.getItem("locale");
        });

        const languagesMenuItems = computed(() => {
            return [
                {
                    label: t("components.common.appTopBar.english"),
                    command: () => changeLocale("gb"),
                },
                {
                    label: t("components.common.appTopBar.serbian"),
                    command: () => changeLocale("rs"),
                },
                {
                    label: t("components.common.appTopBar.slovenian"),
                    command: () => changeLocale("si"),
                },
            ];
        });

        const selectDateRange = async (event) => {
            selectedDateRangeOption.value = dateRangeOptions.value.find((v) => v.code === event.value.code);

            if (event.value.code === "custom") {
                editDateModal.value = true;
            } else {
                let date = new Date();

                if (event.value.code === "l7d") {
                    let dateFrom = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 6);
                    let dateTo = new Date(date.getFullYear(), date.getMonth(), date.getDate());

                    calendarRange.value[0] = dateFrom;
                    calendarRange.value[1] = dateTo;
                }

                if (event.value.code === "l30d") {
                    let dateFrom = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 30);
                    let dateTo = new Date(date.getFullYear(), date.getMonth(), date.getDate());

                    calendarRange.value[0] = dateFrom;
                    calendarRange.value[1] = dateTo;
                }

                if (event.value.code === "l90d") {
                    let dateFrom = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 90);
                    let dateTo = new Date(date.getFullYear(), date.getMonth(), date.getDate());

                    calendarRange.value[0] = dateFrom;
                    calendarRange.value[1] = dateTo;
                }

                if (event.value.code === "mtd") {
                    let dateFrom = new Date(date.getFullYear(), date.getMonth(), 1);
                    let dateTo = new Date(date.getFullYear(), date.getMonth(), date.getDate());

                    calendarRange.value[0] = dateFrom;
                    calendarRange.value[1] = dateFrom > dateTo ? dateFrom : dateTo;
                }

                if (event.value.code === "ytd") {
                    let dateFrom = new Date();
                    dateFrom.setMonth(0);
                    dateFrom.setDate(1);

                    calendarRange.value[0] = dateFrom;
                    calendarRange.value[1] = date;
                }

                if (event.value.code === "cq") {
                    let dateFrom = new Date();

                    if (date.getMonth() <= 11) {
                        dateFrom.setMonth(9);
                        dateFrom.setDate(1);
                    }

                    if (date.getMonth() <= 8) {
                        dateFrom.setMonth(6);
                        dateFrom.setDate(1);
                    }

                    if (date.getMonth() <= 5) {
                        dateFrom.setMonth(3);
                        dateFrom.setDate(1);
                    }

                    if (date.getMonth() <= 2) {
                        dateFrom.setMonth(0);
                        dateFrom.setDate(1);
                    }

                    calendarRange.value[0] = dateFrom;
                    calendarRange.value[1] = date;
                }

                if (event.value.code === "pq") {
                    date = new Date();

                    let dateFrom = new Date();

                    if (date.getMonth() <= 2) {
                        dateFrom.setFullYear(dateFrom.getFullYear() - 1);
                        dateFrom.setMonth(9);
                        dateFrom.setDate(1);
                    } else if (date.getMonth() <= 5) {
                        dateFrom.setMonth(0);
                        dateFrom.setDate(1);
                    } else if (date.getMonth() <= 8) {
                        dateFrom.setMonth(3);
                        dateFrom.setDate(1);
                    } else if (date.getMonth() <= 11) {
                        dateFrom.setMonth(6);
                        dateFrom.setDate(1);
                    }

                    let dateTo = new Date(dateFrom);
                    dateTo.setMonth(dateTo.getMonth() + 3);
                    dateTo.setDate(0);

                    calendarRange.value[0] = dateFrom;
                    calendarRange.value[1] = dateTo;
                }

                if (event.value.code === "ly") {
                    let dateFrom = new Date();
                    let dateTo = new Date();

                    dateFrom.setFullYear(date.getFullYear() - 1);
                    dateFrom.setMonth(0);
                    dateFrom.setDate(1);

                    dateTo.setFullYear(date.getFullYear() - 1);
                    dateTo.setMonth(11);
                    dateTo.setDate(31);

                    calendarRange.value[0] = dateFrom;
                    calendarRange.value[1] = dateTo;
                }

                if (event.value.code === "lm") {
                    let dateFrom = new Date();
                    dateFrom.setMonth(dateFrom.getMonth() - 1);
                    dateFrom.setDate(1);
                    let dateTo = new Date();
                    dateTo.setDate(0);

                    calendarRange.value[0] = dateFrom;
                    calendarRange.value[1] = dateTo;
                }

                fetchTableDataByReport();
            }
        };

        const confirmEditDateModal = async () => {
            calendarRange.value = chosenDateRange.value;
            editDateLoading.value = true;

            if (!calendarRange.value[1]) {
                calendarRange.value[1] = new Date();
            }

            fetchTableDataByReport();

            editDateLoading.value = false;
            editDateModal.value = false;
        };

        const setLanguage = (event) => {
            event.value.command();
        };

        const { isMobile } = useMobileDetection();

        const toggleProfileMenu = (event) => {
            profileMenu.value.toggle(event);
        };

        watch(useI18n().locale, () => {
            dateRangeOptions.value[0].name = t("components.common.appTopBar.dateRangeOptions.l7d");
            dateRangeOptions.value[1].name = t("components.common.appTopBar.dateRangeOptions.l30d");
            dateRangeOptions.value[2].name = t("components.common.appTopBar.dateRangeOptions.l90d");
            dateRangeOptions.value[3].name = t("components.common.appTopBar.dateRangeOptions.mtd");
            dateRangeOptions.value[4].name = t("components.common.appTopBar.dateRangeOptions.ytd");
            dateRangeOptions.value[5].name = t("components.common.appTopBar.dateRangeOptions.cq");
            dateRangeOptions.value[6].name = t("components.common.appTopBar.dateRangeOptions.pq");
            dateRangeOptions.value[7].name = t("components.common.appTopBar.dateRangeOptions.ly");
            dateRangeOptions.value[8].name = t("components.common.appTopBar.dateRangeOptions.lm");
            dateRangeOptions.value[9].name = t("components.common.appTopBar.dateRangeOptions.custom");
        });

        return {
            calendarRange,
            changeLocale,
            chosenDateRange,
            chosenLanguage,
            confirmEditDateModal,
            dateFrom,
            dateRangeOptions,
            dateTo,
            editDateLoading,
            editDateModal,
            formatDate,
            isMobile,
            languageMenu,
            languagesMenuItems,
            locale,
            logout,
            maxDate,
            menu,
            onMenuToggle,
            profileDropDownOptions,
            profileMenu,
            search,
            selectDateRange,
            selectedDateRangeOption,
            selectedShop,
            setLanguage,
            toggleLanguagesMenu,
            toggleProfileMenu,
            user,
        };
    },
    emits: ["menuToggle"],
};
</script>

<style lang="scss">
.datepicker-subtitle {
    font-size: 12px;
}

.kam {
    font-size: 12px;
    margin: 10px;
}

.p-menu-list > .p-menuitem {
    color: #197698;
    font-size: 10px;
    font-weight: 600;
    line-height: 12px;
    padding-bottom: 10.5px;
    padding-left: 14px;
    padding-right: 14px;
    padding-top: 10.5px;
}
</style>
